import React from 'react'

const Footer = () => {
  return (
    <div className='mt-24'>
      <div className='dark:text-gray-200 text-gray-700 text-center m-20'>

      Made with ❤️ by Tdmund | credit JSM © 2022 All rights reserved by edShoppy.com
      </div>
    </div>
  )
}

export default Footer